import { Redirect } from "expo-router";

export default function AppIndexWeb() {
    return <Redirect href="/" />;
} 